export default {
  action: 'עמודות',
  label: 'סידור ותצוגת עמודות',
};
